export interface Hud {
  setText(text: string): void
  hide(): void
}

/**
 * The single-line hint above the safe area.
 *
 * `pointer-events: none` in the stylesheet is load-bearing: the hint sits over
 * the camera feed and would otherwise swallow placement taps aimed at the floor
 * behind it.
 */
export const createHud = (elementId: string): Hud => {
  const element = document.getElementById(elementId)
  if (!(element instanceof HTMLElement)) {
    throw new Error(`HUD element #${elementId} not found`)
  }

  return {
    setText: (text) => {
      element.textContent = text
      element.hidden = false
    },
    hide: () => {
      element.hidden = true
    },
  }
}
